<template>
  <form>
    <!-- CAMPAIGN SETTINGS -->
    <basic-info-section :project='project' :errors='errors' :submit='submit'></basic-info-section>
    <!-- CAMPAIGN DETAILS -->
    <div class="container profile-details crowd your-campaign-details" id="scrollTo">
      <!-- Basics, Rewards, Team -->
      <div class="row">
        <transition-group name="fade" mode="out-in" appear>
          <div class="col-md-12" v-show="showDetails" key="details">
            <!-- Nav tabs -->
            <ul class="nav nav-tabs" role="tablist" id="crowdtabs">
              <li><a class="first uppercase">{{ $t("project.details") }}</a></li>
              <li role="presentation" class="active">
                <a href="#your-campaign-basics" aria-controls="profile-about" role="tab" data-toggle="tab">{{ $t("project.basics") }}</a>
              </li>
              <li role="presentation" :class="{disabled: isNewProject()}">
                <a href="#your-campaign-story" aria-controls="profile-campaigns" role="tab" data-toggle="tab" ref="reward">
                  <tooltip v-if="isNewProject()" :title="'add rewards for your project in next step'">
                    {{ $t("rewards") }}
                  </tooltip>
                  <p v-else>{{ $t("rewards") }}</p>
                </a>
              </li>
              <li role="presentation" :class="{disabled: isNewProject()}">
                <a href="#your-campaign-team" aria-controls="profile-contributions" role="tab" data-toggle="tab">
                  <tooltip v-if="isNewProject()" :title="'finish this step to invite friends to your campaign'">
                    {{ $t("team.team") }}
                  </tooltip>
                  <p v-else>{{ $t("team.team") }}</p>
                </a>
              </li>
            </ul>
            <!-- Tab panes -->
            <div class="tab-content">
              <!-- Basics -->
              <div role="tabpanel" class="tab-pane fade in active" id="your-campaign-basics">
                <details-section v-if="isNewProject() || project.id"
                  :project.sync='project'
                  :submit='submit'
                  :alert='alert'>
                </details-section>
              </div>
              <!-- Story&Rewards -->
              <div v-if="!isNewProject()" role="tabpanel" class="tab-pane fade disabled" id="your-campaign-story">
                <rewards-section :project="project"></rewards-section>
              </div>
              <!-- Team -->
              <div v-if="!isNewProject()" role="tabpanel" class="tab-pane fade" id="your-campaign-team">
                <team-section :project="project"></team-section>
              </div>
            </div><!-- .tab-content -->
          </div><!-- .col-md-12 -->
          <div v-show="!showDetails" key="info">
            <h2>{{ $t('project.form.showDetailsInfo') }}</h2>
          </div>
        </transition-group>
      </div><!-- .row -->
      <hr/>
    </div>
  </form>
</template>

<script>
// Components
import BasicInfoSection from '@/components/Project/Form/Basic';
import DetailsSection from '@/components/Project/Form/Details';
import RewardsSection from '@/components/Project/Form/Rewards';
import TeamSection from '@/components/Project/Form/Team';
import Tooltip from '@/components/Tooltip';

export default {
  components: { RewardsSection, BasicInfoSection, DetailsSection, TeamSection, Tooltip },
  methods: {
    isNewProject() {
      return !this.$route.params.id;
    },
    selectRewardTab() {
      if (this.$route.query.tab === 'reward') {
        this.$refs.reward.click();
      }
    },
  },
  computed: {
    showDetails() {
      return this.project.id;
    },
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
    submit: {
      action: Function,
      processing: Boolean,
    },
    errors: Object,
    alert: Object,
  },
  mounted() {
    this.selectRewardTab();
  },
};
</script>



// WEBPACK FOOTER //
// Form.vue?065bcaa2